// Détection de la page v2, sans dépendance : importée par RouterPage (<head>) et le thème.
// Page v2 : campagne réglée en « V2 », ou aperçu explicite ?design=v2.
// ?design=v1 réaffiche l'ancienne page d'une campagne v2 (retour arrière immédiat).
export function isCampagneV2(campagneData, query = {}) {
    const design = query?.design
    if (design === "v1") return false
    if (design === "v2") return true
    return campagneData?.config?.template === "V2"
}
